// extracted by mini-css-extract-plugin
module.exports = {"section":"SwiperAni_section__e5d7d","space1":"SwiperAni_space1__r_Jfj","space2":"SwiperAni_space2__YB0_O"};